"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var stageW = 0; // 画面の幅

var stageH = 0; // 画面の高さ
// canvas要素の参照を取得

var canvas = document.querySelector('canvas.streamline'); // 2Dの描画命令群を取得

var context = canvas.getContext('2d');
noise.seed(Math.random());
resize();
tick();
window.addEventListener('resize', resize); // エンターフレームのタイミング

function tick() {
  requestAnimationFrame(tick);
  var time = Date.now() / 3000;
  draw(time);
} // 描画


function draw(time) {
  // 画面をリセット
  context.clearRect(0, 0, stageW, stageH);
  context.lineWidth = 1;
  var amplitude = stageH / 3; // 振幅（縦幅)の大きさ

  var lineNum = 200; // ラインの数

  var segmentNum = 100; // 分割数

  _toConsumableArray(new Array(lineNum).keys()).forEach(function (j) {
    var coefficient = 50 + j;
    context.beginPath(); // context.strokeStyle = `white`;
    // context.strokeStyle = 'rgb(155, 187, 89)';

    context.strokeStyle = '#3DFF3D'; // context.strokeStyle = '#00FC00';
    // const h = Math.round(j / lineNum * 220); // 色相
    // const s = 100; // 彩度
    // const l = Math.round(j / lineNum * 100); // 明度
    // // 色を指定
    // context.strokeStyle = `hsl(${h}, ${s}%, ${l}%)`;

    _toConsumableArray(new Array(segmentNum).keys()).forEach(function (i) {
      var x = i / (segmentNum - 1) * stageW;
      var px = i / coefficient;
      var py = j / 50 + time;
      var y = amplitude * noise.perlin2(px, py) + stageH / 2;

      if (i === 0) {
        context.moveTo(x, y);
      } else {
        context.lineTo(x, y);
      }
    });

    context.stroke();
  });
} // リサイズイベント


function resize() {
  stageW = innerWidth * devicePixelRatio;
  stageH = innerHeight * devicePixelRatio;
  canvas.width = stageW;
  canvas.height = stageH;
}